import { Component, OnInit } from '@angular/core';
import { ROUTES } from 'src/app/constants/Routes';


@Component({
  selector: 'app-w4iq',
  templateUrl: './w4iq.component.html',
  styleUrls: ['./w4iq.component.scss'],
  standalone: false
})
export class W4IQComponent implements OnInit {
  Routes = ROUTES;
  activeSection = 'overview';

  sections = [
    { id: 'overview', label: 'Overview', icon: 'bx-layer' },
    { id: 'streaming', label: 'Streaming', icon: 'bx-broadcast' },
    { id: 'data-layers', label: 'Data Layers', icon: 'bx-data' },
    { id: 'flow', label: 'Data Flow', icon: 'bx-transfer' },
  ];

  streamingCapabilities = [
    'High-throughput real-time data ingestion from devices and applications.',
    'Event buffering and distribution for multiple downstream consumers.',
    'Fault-tolerant streaming layer for continuous telemetry flow.',
    'Decoupled producer-consumer architecture for scale and resilience.',
    'Kafka-backed event backbone for guaranteed delivery and replay.',
  ];

  dataLayers = [
    {
      title: 'Hot Data Layer',
      badge: 'Small Brain',
      icon: 'bx-bolt-circle',
      desc: 'Low-latency layer retaining recent data for live queries, near real-time analytics, and monitoring services. Optimized for sub-second response times.',
      metrics: ['Live vehicle tracking', 'Real-time alerts', 'Active session queries'],
    },
    {
      title: 'Cold Data Layer',
      badge: 'Big Brain',
      icon: 'bx-archive',
      desc: 'Historical layer optimized for deep analytics, trend analysis, and reporting over longer time windows. Feeds AI/ML and business intelligence pipelines.',
      metrics: ['Trip history & analytics', 'Behavior trend reports', 'UBI scoring datasets'],
    },
  ];

  streamingFlow = [
    { step: '01', label: 'Ingestion', desc: 'Events arrive from devices and applications into the Kafka-backed streaming layer.' },
    { step: '02', label: 'Processing', desc: 'Streaming consumers validate, enrich, and normalize events in real time.' },
    { step: '03', label: 'Persistence', desc: 'Structured data is written into query-ready NoSQL storage for both layers.' },
    { step: '04', label: 'Serving', desc: 'APIs, dashboards, analytics, and ML pipelines consume data from both layers.' },
  ];

  ngOnInit() {}


  scrollTo(sectionId: string) {
    const el = document.getElementById(sectionId);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    this.activeSection = sectionId;
  }

  private setupIntersectionObserver() {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) this.activeSection = entry.target.id;
        });
      },
      { rootMargin: '-20% 0px -70% 0px' }
    );
    this.sections.forEach(s => {
      const el = document.getElementById(s.id);
      if (el) observer.observe(el);
    });
  }
}
